import esFormTable from './elem-form'
import esQuerySelect from './lib/querySelect'


const components = [
  esFormTable,
  esQuerySelect
];

const install = function (Vue, opts = {}) {
  if (install.installed) return;
  // 遍历注册全局组件
  components.map(component => Vue.component(component.name, component));

  Vue.prototype.$ESFORMTABLE = {
    dataPath: opts.dataPath || '',
    totalPath: opts.totalPath || ''
  };
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  version: '1.0.0',
  install,
  esFormTable,
  esQuerySelect
}
